import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { FileResponse } from '../model/file.model';
import { IAppCategoryListServerResponse } from './category.model';
import { GroupInvoicePayload } from './generateInvoiceView.model';
import { PaginationItems } from '@modules/table-pagination/interfaces/pagination-items.interface';
import { ServiceRequestFileInterface } from '@interfaces/service-request/service-request-file.interface';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  // todo need to rewrite functionality without using profileUrl
  profileUrl: BehaviorSubject<string> = new BehaviorSubject<string>('../../../assets/img/avatar3.png');

  constructor(private httpClient: HttpClient) {}

  uploadFile(fileType: string, tableName: string, tableValue: string, fileInfo: FormData): Observable<FileResponse[]> {
    const url = `${environment.apiHost}/Files/uploadFile/${fileType}/${tableName}/${tableValue}`;

    return this.httpClient.post<FileResponse[]>(url, fileInfo).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  fetchFiles(
    entityTableName: string,
    entityTableValue: string,
    page = 1,
    pageSize = 20,
  ): Observable<PaginationItems<ServiceRequestFileInterface>> {
    const url = `${environment.apiHost}/Files/downloadFile/${entityTableName}/${entityTableValue}`;

    return this.httpClient
      .get<PaginationItems<ServiceRequestFileInterface>>(url, { params: { page, pageSize } })
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  downloadGroupedFilesBySRIdList(serviceRequestIdList: GroupInvoicePayload) {
    const url = `${environment.apiHost}/Files/downloadSRGroupedFile`;

    return this.httpClient.post(url, serviceRequestIdList).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  editProfilePictureAsync(fileType: string, tableName: string, tableValue: string, fileInfo: FormData): Observable<FileResponse[]> {
    const url = `${environment.apiHost}/Files/editProfile/${fileType}/${tableName}/${tableValue}`;

    return this.httpClient.post<FileResponse[]>(url, fileInfo).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  downloadBlob(fileUrl: string): Observable<Blob> {
    const url = `${environment.apiHost}/Files/DownloadBlob`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient
      .post(url, JSON.stringify(fileUrl), { headers: headers, responseType: 'blob' })
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getFileAttachmentTags(): Observable<IAppCategoryListServerResponse> {
    const url = `${environment.apiHost}/AppCategory/GetFileAttachmentTags`;
    return this.httpClient.get<IAppCategoryListServerResponse>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  deletedFile(fileId: string): Observable<FileResponse[]> {
    const url = `${environment.apiHost}/Files/deleteFile?fileId=${fileId}`;

    return this.httpClient.delete<FileResponse[]>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  pinFile(fileId: string): Observable<unknown> {
    const url = `${environment.apiHost}/Files/togglePin/${fileId}`;

    return this.httpClient.put(url, {});
  }
}
